import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import addUserValidation from "../../constant/validations/form.validation.messages";

// const validation = Yup.object().shape({
//   quantity: Yup.string().required("Please Enter Quantity*"),
// });

const validation = Yup.object().shape({
  service: Yup.array().of(
    Yup.object().shape({
      quantity: Yup.number()
        .typeError("Please Enter Quantity*")
        .required("Please Enter Quantity*"),
      expectedDate: Yup.string().required("Please select expected date"),
    })
  )
});

export default { resolver: yupResolver(validation) };
